import React from "react";
import PropTypes from "prop-types";
import {
  CommuneIcon,
  DownArrow,
  Locations,
  Logo,
  Mayor,
  Population,
  Line,
  Search,
} from "../../assets";
import MapLux from "./MapLux";
import MapCommune from "./MapCommune";
import { locales } from "../../locales";
import { formatNumber } from "../../utils/communesUtils";

const Commune = ({
  data,
  scrollHandler,
  goToSearchHandler,
  communeData,
  langId,
  communeId,
  hasElectionSystemChanged,
}) => {
  const mergedCommunesIds = (id) => {
    if (id === 111) {
      return 40;
    }
    if (id === 113) {
      return 37;
    }
    if (id === 112) {
      return 14;
    }
    return id;
  };
  return (
    <div className="mb-10">
      <div className="flex flex-col justify-start pt-16 wort-medium:flex-row border-2 border-gray-200 border-t-0 border-l-0 border-r-0">
        <Logo className="mr-5" style={{ width: 63, height: 53 }} />

        <div className="flex flex-col wort-medium:flex-row wort-medium:justify-between wort-medium: w-full mb-3">
          <div className=" w-1/2">
            <h1 className="font-bold text-32 leading-38 mt-2 wort-medium:text-5xl wort-medium:leading-[40px]">
              {langId === "pt" && communeId === "54"
                ? "Luxemburgo"
                : data?.commune
                ? data.commune
                : communeData.commune}
            </h1>
            <span className="text-xs">
              {" "}
              {/* {locales[langId].lastUpdateDate}:{" "}
              {data?.lastUpdateDate ? data.lastUpdateDate : "14.4.2023"} */}
            </span>
          </div>

          <button
            className="uppercase py-2 flex flex-row items-center wort-medium:justify-center wort-medium:px-2"
            onClick={goToSearchHandler}
          >
            <span className="text-primary mr-2 font-semibold relative">
              {locales[langId].searchMore}
            </span>
            <Search className="ml-2" />
          </button>
        </div>
      </div>
      <div className="flex flex-col wort-medium:flex-row">
        <div className="flex flex-row justify-center pt-6 w-full wort-medium:w-1/2">
          {data && (
            <>
              <MapLux id={mergedCommunesIds(communeData.id)} />
              <Line className="mx-10" />
              <MapCommune id={mergedCommunesIds(communeData.id)} />
            </>
          )}
        </div>
        {data && (
          <div className="flex flex-row pt-6 wort-medium:w-1/2">
            <div className="flex flex-col w-full">
              <span className=" font-extrabold text-22 leading-6">
                {locales[langId].communeInDetail}
              </span>
              <div className="grid grid-cols-2 gap-4 mt-4 mb-6">
                <div className="px-4 pt-2.5 bg-wort-background h-67">
                  <div className="flex flex-row items-center">
                    <Population className="mr-2 w-[28px] h-[22.6px]" />
                    <span className="text-xs wort-medium:text-sm">
                      {locales[langId].residents}
                    </span>
                  </div>
                  <div className="flex flex-row items-baseline">
                    <span className="font-semibold leading-6 mr-2 mt-2 text-secondary wort-medium:leading-lw wort-medium:text-22">
                      {formatNumber(communeData.currentPopulation)}
                    </span>
                    <span className=" text-xs">(01.01.2023)</span>
                  </div>
                </div>
                <div className="px-4 pt-2 bg-wort-background h-67 ">
                  <div className="flex flex-row items-center">
                    <Locations className="mr-2 w-[28px] h-[22.6px]" />
                    <span className="text-xs wort-medium:text-sm">
                      {locales[langId].numberOfLocalities}
                    </span>
                  </div>
                  <div className="flex flex-row items-baseline">
                    <span className="font-semibold text-lg leading-6 mt-1 text-secondary wort-medium:leading-lw wort-medium:text-22">
                      {communeData.numberOfLocalities}
                    </span>
                  </div>
                </div>
                <div className="px-4 pt-2.5 bg-wort-background h-[100px] pb-1">
                  <div className="flex flex-row items-center">
                    <Mayor className="mr-2 w-[28px] h-[22.6px]" />
                    <span className="text-xs wort-medium:text-sm">
                      {locales[langId].incumbentMayor}
                    </span>
                  </div>
                  <div className="flex flex-col items-baseline">
                    <span className="font-semibold text-lg leading-6 mr-2 mt-2 text-secondary wort-medium:leading-lw wort-medium:text-22">
                      {communeData.mayor.firstName} {communeData.mayor.lastName}
                    </span>
                    <span
                      className="mt-2"
                      style={{
                        fontWeight: 600,
                        fontSize: "14px",
                        lineHeight: "17px",
                      }}
                    >
                      {communeData.mayor.party}
                    </span>
                  </div>
                </div>
                <div className="px-4 pt-2.5 bg-wort-background h-[100px]">
                  <div className="flex flex-row items-center">
                    <CommuneIcon className="mr-2 w-[28px] h-[22.6px]" />
                    <span className="text-xs wort-medium:text-sm">
                      {locales[langId].typeOfCommune}
                    </span>
                  </div>
                  <div className="flex flex-row items-baseline">
                    <span className="font-semibold leading-6 mr-2 mt-2 text-secondary wort-medium:leading-lw wort-medium:text-22">
                      {data ? data.type : ""}
                    </span>
                    {hasElectionSystemChanged && (
                      <span className="text-xs">
                        {locales[langId].electionSystemChanged}
                      </span>
                    )}
                  </div>
                </div>
              </div>
              <button
                className="h-10 mb-6 border-2 border-primary uppercase py-2 px-2 flex flex-row items-center justify-center wort-medium:w-263 group"
                onClick={scrollHandler}
              >
                <span className="text-primary mr-2 font-semibold relative">
                  {locales[langId].moreToTheCommune}
                  <span className="absolute bottom-0 left-1/2 w-0 h-0.5 bg-primary transition-all duration-500 ease-in-out transform group-hover:w-full group-hover:-translate-x-1/2"></span>
                </span>
                <DownArrow className="btransition-transform duration-500 ease-in-out group-hover:translate-y-1" />
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

Commune.propTypes = {
  data: PropTypes.object,
};

export default Commune;
